import { render, staticRenderFns } from "./MainMenu.2.vue?vue&type=template&id=703d05d0&scoped=true&"
import script from "./MainMenu.2.vue?vue&type=script&lang=js&"
export * from "./MainMenu.2.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.2.vue?vue&type=style&index=0&id=703d05d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d05d0",
  null
  
)

export default component.exports